export default "__VITE_ASSET__mHfCtDHN__"